import React, { useEffect, useMemo, useState } from "react";

/** Robust slideshow for CRA/Vite + nested routes */
function Slide({ source, active, height }) {
  const publicBase = process.env.PUBLIC_URL || "";
  const nameOnly = typeof source === "string" ? source.replace(/^\/+/, "") : source;
  const candidates = Array.from(
    new Set(
      [
        source,                      // as given
        `/${nameOnly}`,              // root-relative (public/)
        `${publicBase}/${nameOnly}`, // PUBLIC_URL/name
      ].filter(Boolean)
    )
  );

  const [idx, setIdx] = useState(0);
  const src = candidates[idx] || "";

  return (
    <img
      src={src}
      alt=""
      onError={() => {
        if (idx < candidates.length - 1) setIdx(idx + 1);
        else console.warn("[Slideshow] failed:", candidates);
      }}
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height,
        objectFit: "cover",
        opacity: active ? 1 : 0,
        transition: "opacity 600ms ease",
      }}
    />
  );
}

export default function SlideshowHero({
  images = [],
  caption = "",
  intervalMs = 5000,
  height = "70vh",
  rounded = true,
  darkOverlay = true,
}) {
  const slides = useMemo(() => images.filter(Boolean), [images]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (slides.length < 2) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % slides.length), intervalMs);
    return () => clearInterval(id);
  }, [slides.length, intervalMs]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height,
        borderRadius: rounded ? 18 : 0,
        overflow: "hidden",
        boxShadow: "0 16px 48px rgba(0,0,0,0.25)",
        background: "#111",
      }}
    >
      {slides.map((s, i) => (
        <Slide key={`${i}-${String(s)}`} source={s} active={i === idx} height={height} />
      ))}
      {darkOverlay && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(180deg, rgba(0,0,0,.25), rgba(0,0,0,.55))",
          }}
        />
      )}
      {caption ? (
        <div
          style={{
            position: "absolute",
            left: 16,
            right: 16,
            bottom: 16,
            color: "#fff",
            fontWeight: 800,
            letterSpacing: 0.3,
            fontSize: 24,
          }}
        >
          {caption}
        </div>
      ) : null}
    </div>
  );
}
